import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const STORAGE_KEY = 'snagcart_cookie_consent_v1';

export default function CookieConsentBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(STORAGE_KEY)) setVisible(true);
    } catch {
      setVisible(true);
    }
  }, []);

  const accept = () => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({ accepted: true, at: new Date().toISOString() }));
    } catch {
      /* ignore */
    }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 inset-x-0 z-[80] p-4 pointer-events-none">
      <div className="mx-auto max-w-3xl rounded-2xl border border-white/10 bg-zinc-950/95 backdrop-blur px-5 py-4 shadow-2xl pointer-events-auto flex flex-col sm:flex-row sm:items-center gap-4">
        <p className="text-sm text-zinc-300 flex-1">
          We use essential cookies for authentication and security. See our{' '}
          <Link to="/privacy" className="text-violet-400 hover:underline">Privacy Policy</Link>
          {' '}and{' '}
          <Link to="/terms" className="text-violet-400 hover:underline">Terms</Link>.
        </p>
        <button
          type="button"
          onClick={accept}
          className="shrink-0 rounded-full bg-white text-black px-5 py-2 text-sm font-semibold"
        >
          Accept
        </button>
      </div>
    </div>
  );
}
